import { ChatContext } from 'context/Context';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setConversation } from 'redux/chatSlice';

const ChatProvider = ({
  children,
  conversations,
  conversation,
  actions,
  currentUser,
  neighborhoodsObj,
  socket
}) => {
  const dispatch = useDispatch();

  const [textAreaInitialHeight, setTextAreaInitialHeight] = useState(32);
  const [activeConversationId, setActiveConversationId] = useState(
    conversations[0]?.id
  );
  const [isOpenConversationInfo, setIsOpenConversationInfo] = useState(false);
  const [scrollToBottom, setScrollToBottom] = useState(true);

  const [isSearchConversation, setIsSearchConversation] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [scrollToMessage, setScrollToMessage] = useState(null);

  const {
    getConversations,
    getConversation,
    sendMessage,
    readMessages,
    searchInConversations
  } = actions;

  const activeConversationFunc = async () => {
    await readMessages(activeConversationId);
    await getConversation(activeConversationId, '4');

    await getConversations();
  };

  const newMessage = async ({ conversationId, updatedConversation }) => {
    if (activeConversationId === conversationId) {
      await dispatch(setConversation({ ...updatedConversation, where: '1' }));
      const conversationReaded = await readMessages(conversationId);
      await dispatch(setConversation({ ...conversationReaded, where: '2' }));
    }

    await getConversations();
    setScrollToBottom(true);
  };

  const readedConversation = async ({
    conversationId,
    updatedConversation
  }) => {
    /* console.log('conversationId', conversationId);
    console.log('activeConversationId', activeConversationId); */
    if (activeConversationId === conversationId) {
      /* console.log(activeConversationId === conversationId); */
      await dispatch(setConversation({ ...updatedConversation, where: '3' }));
    }

    await getConversations();
  };

  useEffect(() => {
    if (socket) {
      socket.removeAllListeners('message');
      socket.on('message', newMessage);
      socket.on('readed-conversation', readedConversation);
    }
  }, [socket]);

  useEffect(() => {
    if (!isLoading) {
      setScrollToBottom(true);
    }
  }, [isLoading]);

  useEffect(() => {
    if (activeConversationId) {
      setIsLoading(true);
      activeConversationFunc()
        .then(() => {
          setIsLoading(false);
        })
        .catch(err => {
          setIsLoading(false);
          console.error(err);
        });
    }
  }, [activeConversationId]);

  const value = {
    conversations,
    getConversations,
    activeConversationId,
    setActiveConversationId,

    sendMessage,
    readMessages,

    textAreaInitialHeight,
    setTextAreaInitialHeight,

    isOpenConversationInfo,
    setIsOpenConversationInfo,

    conversation,
    getConversation,

    scrollToBottom,
    setScrollToBottom,

    searchInConversations,
    isSearchConversation,
    setIsSearchConversation,

    scrollToMessage,
    setScrollToMessage,

    isLoading,
    setIsLoading,

    currentUser,

    neighborhoodsObj
  };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

ChatProvider.propTypes = {
  children: PropTypes.node.isRequired,
  conversations: PropTypes.array.isRequired,
  conversation: PropTypes.object,
  actions: PropTypes.shape({
    getConversations: PropTypes.func.isRequired,
    getConversation: PropTypes.func.isRequired,
    sendMessage: PropTypes.func.isRequired,
    readMessages: PropTypes.func.isRequired,
    searchInConversations: PropTypes.func.isRequired
  }),
  currentUser: PropTypes.object.isRequired,
  neighborhoodsObj: PropTypes.object.isRequired,
  socket: PropTypes.object.isRequired
};

export default ChatProvider;
